import React, { useContext, useEffect, useMemo, useRef } from "react"
import { ScrollContext } from "../context"
import { CATALOG } from "../data/catalog"
import map from "lodash/map"
import forEach from "lodash/forEach"
import keyBy from "lodash/keyBy"
import last from "lodash/last"
import { navigate as gatsbyNavigate } from "gatsby"
import MobileAnimator from "./AnimatorMobile"
import { Waypoint } from "react-waypoint"

const PositionerMobile = ({ location, innerRef, navigate }) => {
  const { y, h, p } = useContext(ScrollContext)
  const isFirstRenderRef = useRef(false)

  const previousP = useRef(null)

  const ANIMATED_CATALOG = useMemo(() => {
    const out = {}
    forEach(CATALOG, (page, url) => {
      if (out[page.y] === undefined) {
        out[page.y] = { ...page, url, urls: [], elements: [] }
      }
      const PageImplementation = page.MobileComponent || page.Component
      out[page.y].elements[page.x] = props => (
        <Waypoint onEnter={({ previousPosition, currentPosition }) => {
          if (previousPosition !== undefined) {
            gatsbyNavigate(url)
          }
        }} topOffset={20} bottomOffset={20}>
          <PageImplementation navigate={navigate} {...page.mobileProps} {...props} />
        </Waypoint>
      )
      out[page.y].urls[page.x] = url
    })
    return keyBy(map(out, pageComposition => {
      const urls = pageComposition.urls.filter(i => !!i)
      return {
        ...pageComposition,
        Component: MobileAnimator(pageComposition.elements.filter(i => !!i), urls),
        urls,
        url: urls[0],
      }
    }), "y")
  }, [navigate])

  useEffect(() => {
    if (previousP.current === null) {
      return
    }
    if (previousP.current > p) {
      // going back
      gatsbyNavigate(last(ANIMATED_CATALOG[p].urls))
    } else if (previousP.current < p) {
      gatsbyNavigate(ANIMATED_CATALOG[p].urls[0])
    }
  }, [ANIMATED_CATALOG, p])

  useEffect(() => {
    previousP.current = p
  })

  useEffect(() => {
    isFirstRenderRef.current = true
  }, [])

  return (
    <>
      {map(ANIMATED_CATALOG, ({ y: pageY, Component, props }, url) => {

        const deltaY = Math.abs(pageY - p)
        if (deltaY >= 2) {
          return null
        }

        const top = y.interpolate(y => -Math.max(0, (y - pageY) * h))
        const bottom = y.interpolate(y => Math.max(0, (y - pageY) * h))

        const planarTop = y.interpolate(y => -(y - pageY) * h)
        const planarBottom = y.interpolate(y => (y - pageY) * h)

        const passProps = { ...props }

        if (pageY === p) {
          passProps.innerRef = innerRef
          if (!isFirstRenderRef.current) passProps.scrollTo = location.pathname
        } else {
          passProps.snapTo = p < pageY ? "start" : "end"
        }

        return (
          <Component
            key={url}
            planarTop={planarTop}
            planarBottom={planarBottom}
            top={top}
            bottom={bottom}
            vh={h}
            {...passProps}
          />
        )
      })}
    </>
  )
}

export default PositionerMobile
